import { useCallback, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';

// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!marketplace-ui-common/img/link-connector.svg'
import linkConnectorIconUrl from 'bender-url!marketplace-ui-common/img/link-connector.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!marketplace-ui-common/img/hubspot-sprocket.svg'
import hubspotSprocketIconUrl from 'bender-url!marketplace-ui-common/img/hubspot-sprocket.svg';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { StepIndicator } from 'foundations-components/transitional/components/StepIndicator';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { getHubSpotSensitiveDataTermsUrl } from 'marketplace-ui-common/utils/DetailsPageUrls';
import { useEnableSensitiveDataAsyncMutation } from '../../__generated__/chirp/com/hubspot/sensitive/data/status/controller/rpc/SensitiveDataStatusControllerFrontendService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SENSITIVE_DATA_LEARN_MORE_URL = 'https://knowledge.hubspot.com/properties/sensitive-data-in-hubspot-tools';
const SensitiveDataLearnMoreLink = ({
  children
}) => /*#__PURE__*/_jsx(Link, {
  href: SENSITIVE_DATA_LEARN_MORE_URL,
  external: true,
  children: children
});
export function SensitiveDataInstallModal({
  onClose,
  onSuccess
}) {
  const {
    iconUrl,
    name
  } = useDetailsPageContext();
  const [sensitiveDataEnabled, setSensitiveDataEnabled] = useState(false);
  const [enableSensitiveData, {
    loading
  }] = useEnableSensitiveDataAsyncMutation();
  const termsUrl = getHubSpotSensitiveDataTermsUrl(getLang());
  const handleEnable = useCallback(() => {
    enableSensitiveData({
      // sensitiveDataResponses is required by the RPC contract but unused for basic opt-in
      variables: {
        sensitiveDataResponses: []
      }
    }).then(result => {
      if (!result.errors) {
        onSuccess();
      } else {
        FloatingAlertStore.addAlert({
          type: 'error',
          message: unescapedText('detailsPage.sensitiveData.modal.enableError')
        });
      }
    }).catch(() => {
      FloatingAlertStore.addAlert({
        type: 'error',
        message: unescapedText('detailsPage.sensitiveData.modal.enableError')
      });
    });
  }, [enableSensitiveData, onSuccess]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 800,
    size: "auto",
    centered: true,
    children: [/*#__PURE__*/_jsxs(Flex, {
      paddingInlineStart: "600",
      paddingInlineEnd: "500",
      paddingBlock: "500",
      backgroundColor: "fill-surface-default",
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.sensitiveData.modal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        inline: true,
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-recessed",
      paddingBlock: "500",
      paddingInline: "600",
      textAlign: "start",
      maxBlockSize: "90vh",
      overflow: "auto",
      children: [/*#__PURE__*/_jsx(Flex, {
        marginBlockEnd: "500",
        children: /*#__PURE__*/_jsx(StepIndicator, {
          direction: "horizontal",
          use: "default",
          stepIndex: 1,
          responsiveBreakpoint: 0,
          stepNames: [unescapedText('detailsPage.install.thirdPartyStep.name', {
            name
          }), unescapedText('detailsPage.install.hubSpotStep.name'), unescapedText('detailsPage.install.completeStep.name')]
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        gap: "600",
        marginBlockEnd: "600",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "center",
          gap: "600",
          children: [/*#__PURE__*/_jsx("img", {
            src: iconUrl,
            width: 72,
            height: 72,
            style: {
              objectFit: 'contain'
            },
            alt: ""
          }), /*#__PURE__*/_jsx(Flex, {
            blockSize: "32px",
            inlineSize: "32px",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx("img", {
              src: linkConnectorIconUrl,
              width: 24,
              height: 24,
              style: {
                objectFit: 'contain'
              },
              alt: ""
            })
          }), /*#__PURE__*/_jsx("img", {
            src: hubspotSprocketIconUrl,
            width: 72,
            height: 72,
            style: {
              objectFit: 'contain'
            },
            alt: ""
          })]
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "heading-500",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "detailsPage.sensitiveData.modal.connecting_jsx",
            elements: {
              AppName: () => /*#__PURE__*/_jsx("strong", {
                children: name
              }),
              Strong: ({
                children
              }) => /*#__PURE__*/_jsx("strong", {
                children: children
              })
            }
          })
        })]
      }), /*#__PURE__*/_jsx(Tile, {
        compact: true,
        children: /*#__PURE__*/_jsxs(TileSection, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h2",
            typography: "heading-500",
            textTransform: "uppercase",
            children: /*#__PURE__*/_jsx("strong", {
              children: name
            })
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockStart: "200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.sensitiveData.modal.description",
              options: {
                name
              }
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "400",
            children: /*#__PURE__*/_jsxs(Tile, {
              compact: true,
              children: [/*#__PURE__*/_jsx(TileSection, {
                children: /*#__PURE__*/_jsx(Text, {
                  as: "strong",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "detailsPage.sensitiveData.modal.configure"
                  })
                })
              }), /*#__PURE__*/_jsx(TileSection, {
                children: /*#__PURE__*/_jsxs(Flex, {
                  alignItems: "start",
                  justifyContent: "space-between",
                  children: [/*#__PURE__*/_jsxs(Flex, {
                    flexDirection: "column",
                    gap: "200",
                    flex: "1 0 0",
                    paddingInlineEnd: "800",
                    children: [/*#__PURE__*/_jsxs(Flex, {
                      alignItems: "center",
                      gap: "100",
                      children: [/*#__PURE__*/_jsx(Text, {
                        as: "strong",
                        typography: "heading-50",
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "detailsPage.sensitiveData.modal.sensitiveDataToggleLabel"
                        })
                      }), /*#__PURE__*/_jsx(HelpIcon, {
                        title: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "detailsPage.sensitiveData.modal.sensitiveDataTooltip"
                        }),
                        alignWithText: true
                      })]
                    }), /*#__PURE__*/_jsx(Text, {
                      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                        message: "detailsPage.sensitiveData.modal.sensitiveDataDescription_jsx",
                        elements: {
                          TermsLink: ({
                            children
                          }) => /*#__PURE__*/_jsx(Link, {
                            href: termsUrl,
                            external: true,
                            children: children
                          }),
                          LearnMoreLink: SensitiveDataLearnMoreLink
                        }
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Toggle, {
                    checked: sensitiveDataEnabled,
                    onChange: e => setSensitiveDataEnabled(e.target.checked)
                  })]
                })
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Flex, {
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsx(LoadingButton, {
          use: "primary",
          loading: loading,
          disabled: !sensitiveDataEnabled,
          onClick: handleEnable,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.sensitiveData.modal.connectApp"
          })
        })
      })]
    })]
  });
}